import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import logo from "../../assets/brand/edureka_banner.png";

const ContactPage = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ougaynt",
        "template_5mqxsqp",
        form.current,
        "cw4yalCuGMjuKE1LS"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message");
          console.error(error);
        }
      );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 bg-white rounded-3xl shadow-2xl overflow-hidden">

          {/* LEFT SIDE - FORM */}
          <div className="p-8 md:p-12 flex items-center">
            <div className="w-full">

              {/* Edureka Branding */}
              <div className="text-center mb-8">
                <img
                  src={logo}
                  alt="Edureka"
                  className="mx-auto h-16 object-contain mb-3"
                />

                <h1 className="text-3xl font-bold text-gray-800">
                  Edureka Enquiry Form
                </h1>

                <p className="text-gray-600 mt-2">
                  Fill in your details and our team will contact you shortly.
                </p>
              </div>

              <form ref={form} onSubmit={sendEmail} className="space-y-5">

                {/* Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Full Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="Enter your full name"
                    className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all duration-300"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>

                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email"
                    className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all duration-300"
                  />
                </div>

                {/* Course Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Course Name
                  </label>

                  <select
                    name="courses"
                    required
                    className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all duration-300"
                  >
                    <option value="">Select Course</option>
                    <option value="MERN Stack Fullstack Development">
                      MERN Stack Fullstack Development
                    </option>
                    <option value="Java Fullstack">Java Fullstack</option>
                    <option value="Python Programming">Python Programming</option>
                    <option value="Data Science & AI">Data Science & AI</option>
                    <option value="Cloud & DevOps">Cloud & DevOps</option>
                    <option value="UI / UX Designing">UI / UX Designing</option>
                    <option value="Digital Marketing">Digital Marketing</option>
                    <option value="Software Testing">Software Testing</option>
                  </select>
                </div>

                {/* Mobile Number */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mobile Number
                  </label>

                  <input
                    type="text"
                    name="number"
                    required
                    placeholder="+91 XXXXX XXXXX"
                    className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all duration-300"
                  />
                </div>

                {/* Message */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>

                  <textarea
                    name="message"
                    required
                    rows="5"
                    placeholder="Write your message here..."
                    className="w-full rounded-xl border border-gray-300 px-4 py-3 resize-none focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all duration-300"
                  ></textarea>
                </div>

                {/* Hidden fields */}
                <input
                  type="hidden"
                  name="website"
                  value="Edureka Website"
                />

                <input
                  type="hidden"
                  name="subject"
                  value="New Enquiry from Edureka Website"
                />

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full rounded-xl bg-orange-500 py-3 text-white font-semibold text-lg shadow-md hover:bg-orange-600 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                  Submit Enquiry
                </button>
              </form>
            </div>
          </div>

          {/* RIGHT SIDE - GOOGLE MAP */}
<div className="h-[450px] md:h-auto">
  <iframe
    title="Edureka Learning Center - Tambaram"
    src="https://www.google.com/maps?q=Edureka+Learning+Center+Tambaram&output=embed"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    className="w-full h-full"
  ></iframe>
</div>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;